<template>
  <f-dashboard-content-wrapper>
    <f-list
      :store="storeId"
      :query="query"
      :fuzzy="fuzzyOptions"
    >
      <template #list-actions="{ state }">
        <div class="is-grid is-aligned m-vertical-12">
          <div class="is-col-8 is-aligned">
            <f-input 
              v-model="state.search"
              placeholder="Recherche"
              size="small" 
            ></f-input>

            <f-select 
              v-model="filters"
              :options="filtersOptions"
              label="label"
              placeholder="Filtres"
              size="small" 
              multiple
            ></f-select>
          </div>
        </div>
      </template>

      <template #list-header="{ state, selectAll }">
        <user-header
          v-model:createdAt="createdAt"
          v-model:name="name"
          v-model:allowedUntil="allowedUntil"
        ></user-header>
      </template>

      <template #list-item="{ item, state, toggleSelection }">
        <user-item
          :user="item"
          :is-selected="state.selected.has(item._id)"
          @toggle-selection="toggleSelection"
        ></user-item>
      </template>

      <template #pagination-custom="{ pagination }">
        <div class="is-aligned-right m-left-20">
          <p>
            <small>
              <span class="is-medium">{{ pagination.total }}</span> résultats
            </small>
          </p>
        </div>
      </template>
    </f-list>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { ref, computed, watch, reactive, toRefs } from 'vue'
  import dayjs from 'dayjs'
  import router from '@core/router'
  import UserItem from './item/user-item'
  import UserHeader from './header/user-header'

  export default {
    setup () {
      const filtersOptions = [{
        label: 'Connectés',
        key: 'connection.online',
        value: true,
      }, {
        label: 'Ont pris un abo',
        key: 'has_subscribed',
        value: true
      }, {
        label: 'Plus inscrits',
        key: 'allowed_until',
        value: { $lt: dayjs().startOf('day').toISOString() }
      }]
      
      const state = reactive({
        createdAt: -1,
        allowedUntil: 0,
        name: 0,
        filters: [],
      })

      const query = computed(() => {
        const filters = {}
        const sort = {}

        state.filters
          .map(filter => {
            return filtersOptions.find(
              item => item.label === filter.label
            )
          })
          .forEach(filter => {
            filters[filter.key] = filter.value
          })

        if (state.createdAt) {
          sort.createdAt = state.createdAt
        }

        if (state.name) {
          sort.name = state.name 
        }

        if (state.allowedUntil) {
          sort.allowed_until = state.allowedUntil 
        }

        return {
          ...filters,
          $sort: {
            ...sort
          },
        }
      })

      const storeId = ref('@freebe/users')

      return { 
        ...toRefs(state),
        storeId,
        query,
        filtersOptions,
        fuzzyOptions: {
          minMatchCharLength: 2,
          keys: ['name'],
        },
      }
    },

    components: {
      UserItem,
      UserHeader,
    },
  }
</script>